import { render } from "./EditUser.vue?vue&type=template&id=4971a84b"
import script from "./EditUser.vue?vue&type=script&lang=js"
export * from "./EditUser.vue?vue&type=script&lang=js"

import "./EditUser.vue?vue&type=style&index=0&id=4971a84b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__